"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactPortal = require("react-portal");

var _Button = _interopRequireDefault(require("../Button"));

var SweetAlertBase = function SweetAlertBase(props) {
  var children = props.children,
      emoji = props.emoji,
      warningText = props.warningText,
      warningTitle = props.warningTitle,
      onClose = props.onClose;
  return /*#__PURE__*/React.createElement(_reactPortal.Portal, {
    isOpened: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "ppl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pp-sweetalert pp-active"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pp-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pp-overlay"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pp-body pp-body-danger"
  }, emoji && /*#__PURE__*/React.createElement("span", {
    className: emoji
  }), warningTitle && /*#__PURE__*/React.createElement("h1", null, warningTitle), warningText && /*#__PURE__*/React.createElement("p", null, warningText), children, onClose && /*#__PURE__*/React.createElement(_Button["default"], {
    className: "pp-button-close",
    tabIndex: 0,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")))))));
};

var _default = SweetAlertBase;
exports["default"] = _default;